module.exports = __webpack_public_path__ + "img/sea.21d78763.png";